import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const ProjectHeader = ({ project, t }) => {
  return (
    <div className="relative h-96 overflow-hidden">
      <img 
        src={project.image} 
        alt={project.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/40 flex items-center">
        <div className="container mx-auto px-4">
          <Link 
            to="/promotion-immobiliere" 
            className="inline-flex items-center text-white hover:text-socabeg-blue-light mb-6 transition-colors"
          >
            <FaArrowLeft className="mr-2" /> {t('realEstateDetail.backToList')}
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">{project.title}</h1>
          <p className="text-xl text-white/90">{project.type}</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectHeader;
